export default "__VITE_ASSET__728e1897__"